import React from 'react';
import {
  getFontSizeForScreen,
  getLineHeightForScreen,
} from '../../utils/fontUtils';
import {
  REGULAR_FONT_FAMILY,
  TITLE_FONT_FAMILY,
  CONTENT_FONT_FAMILY,
} from '../../utils/fonts';

export { getFontSizeForScreen, getLineHeightForScreen };

interface FontTextProps extends React.HTMLAttributes<HTMLElement> {
  h1?: boolean;
  h2?: boolean;
  h3?: boolean;
  h4?: boolean;
  small?: boolean;
  tiny?: boolean;
  normal?: boolean;
  isContent?: boolean;
  children: React.ReactNode;
}

export const FontText: React.FC<FontTextProps> = ({
  style,
  h1,
  h2,
  h3,
  h4,
  small,
  tiny,
  normal,
  isContent,
  ...props
}) => {
  let fontFamily = REGULAR_FONT_FAMILY;
  if (h1 || h2 || h3 || h4) {
    fontFamily = TITLE_FONT_FAMILY;
  } else if (isContent) {
    fontFamily = CONTENT_FONT_FAMILY;
  }

  let fontSize: number;
  if (h1) fontSize = getFontSizeForScreen('h1');
  else if (h2) fontSize = getFontSizeForScreen('h2');
  else if (h3) fontSize = getFontSizeForScreen('h3');
  else if (h4) fontSize = getFontSizeForScreen('h4');
  else if (small) fontSize = getFontSizeForScreen('small');
  else if (tiny) fontSize = getFontSizeForScreen('tiny');
  else if (normal) fontSize = getFontSizeForScreen('normal');
  else fontSize = getFontSizeForScreen('normal');

  let lineHeight: number;
  if (h1) lineHeight = getLineHeightForScreen('h1');
  else if (h2) lineHeight = getLineHeightForScreen('h2');
  else if (h3) lineHeight = getLineHeightForScreen('h3');
  else if (h4) lineHeight = getLineHeightForScreen('h4');
  else if (small) lineHeight = getLineHeightForScreen('small');
  else if (tiny) lineHeight = getLineHeightForScreen('tiny');
  else if (normal) lineHeight = getLineHeightForScreen('normal');
  else if (isContent) lineHeight = getLineHeightForScreen('h4');
  else lineHeight = getLineHeightForScreen('normal');

  let tagName = 'div';
  if (h1) tagName = 'h1';
  else if (h2) tagName = 'h2';
  else if (h3) tagName = 'h3';
  else if (h4) tagName = 'h4';

  const elementStyle = {
    fontSize: `${fontSize}px`,
    fontFamily,
    lineHeight: `${lineHeight}px`,
    paddingLeft: `${fontSize / 6}px`,
    paddingRight: `${fontSize / 6}px`,
    margin: 0,
    ...style,
  };

  return React.createElement(
    tagName,
    {
      style: elementStyle,
      ...props,
    },
    props.children
  );
};
